/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import gql from 'graphql-tag';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';

import { ValidationErrorFieldsFragmentDoc } from '../../../graphql/fragments/ValidationErrorFields.generated';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type AddLineItemToCartInput = {
  readonly additions: ReadonlyArray<IngredientModificationInput>;
  readonly customName?: string | null | undefined;
  readonly deliveryOrderDetails?: DeliveryOrderDetailInput | null | undefined;
  readonly mixedDressingDetails: ReadonlyArray<MixedDressingDetailsInput>;
  readonly productId: string | number;
  readonly quantity: number;
  readonly removals: ReadonlyArray<IngredientModificationInput>;
  readonly restaurantId?: number | null | undefined;
  /** Per-line-item special instructions (catering). Persisted to gravy_special_instructions after submission. */
  readonly specialInstructions?: string | null | undefined;
  readonly substitutions: ReadonlyArray<IngredientSubstitutionModificationInput>;
};

export type DeliveryOrderDetailInput = {
  readonly addressId: string | number;
  readonly deliveryFee: number;
  readonly tip: number;
  readonly vendor: string;
  readonly vendorRestaurantId: string;
};

export type DeliveryPreferenceType = 'CURBSIDE' | 'DOOR' | 'LEAVE_AT_DOOR';

export type DressingMode = 'MIXED' | 'NOT_DRESSABLE' | 'ON_THE_SIDE' | 'REMOVED';

export type DressingWeight = 'HEAVY' | 'LIGHT' | 'MEDIUM';

export type EditLineItemInCartInput = {
  readonly additions: ReadonlyArray<IngredientModificationInput>;
  readonly customName?: string | null | undefined;
  readonly lineItemId: string | number;
  readonly mixedDressingDetails: ReadonlyArray<MixedDressingDetailsInput>;
  readonly productId: string | number;
  readonly quantity: number;
  readonly removals: ReadonlyArray<IngredientModificationInput>;
  /** Per-line-item special instructions (catering). Persisted to gravy_special_instructions after submission. */
  readonly specialInstructions?: string | null | undefined;
  readonly substitutions: ReadonlyArray<IngredientSubstitutionModificationInput>;
};

export type IngredientKind = 'BASE' | 'DRESSING' | 'PREMIUM' | 'TOPPING';

export type IngredientModificationInput = {
  readonly ingredientId: string | number;
};

export type IngredientSubstitutionModificationInput = {
  readonly addedIngredientId: string | number;
  readonly removedIngredientId: string | number;
};

export type MixedDressingDetailsInput = {
  readonly ingredientId: string | number;
  readonly weight: DressingWeight;
};

export type ModifierType = 'ADDITION' | 'INCLUDED' | 'MIXED_DRESSING' | 'REMOVAL' | 'SUBSTITUTION';

export type OrderState =
  | 'Active'
  | 'Canceled'
  | 'Complete'
  | 'Discarded'
  | 'LockedChangeLocation'
  | 'LockedCheckout';

export type OrderType =
  | 'CATERING'
  | 'CATERING_DELIVERY'
  | 'CATERING_PICKUP'
  | 'DELIVERY'
  | 'IN_STORE'
  | 'PICKUP';

export type RemoveFromCartInput = {
  readonly lineItemId: string | number;
};

export type CartLedgerFragment = {
  readonly tax: number;
  readonly subtotal: number;
  readonly feesTotal: number;
  readonly discountsTotal: number;
  readonly creditsTotal: number;
  readonly tip: number;
  readonly discounts: ReadonlyArray<{
    readonly __typename: 'LedgerItem';
    readonly id: string | null;
    readonly name: string;
    readonly amount: number;
    readonly description: string | null;
  }>;
  readonly credits: ReadonlyArray<{
    readonly __typename: 'LedgerItem';
    readonly id: string | null;
    readonly name: string;
    readonly amount: number;
    readonly description: string | null;
  }>;
  readonly fees: ReadonlyArray<{
    readonly __typename: 'LedgerItem';
    readonly id: string | null;
    readonly name: string;
    readonly amount: number;
    readonly description: string | null;
  }>;
};

export type CartLineItemFragment = {
  readonly __typename: 'LineItem';
  readonly id: string;
  readonly slug: string;
  readonly quantity: number;
  readonly cost: number;
  readonly customName: string | null;
  readonly perItemCost: number;
  readonly favorited: boolean;
  readonly isCustom: boolean;
  readonly dressingMode: Types.DressingMode;
  readonly addedIngredients: ReadonlyArray<{
    readonly __typename: 'Ingredient';
    readonly id: string;
    readonly name: string;
    readonly kind: Types.IngredientKind | null;
    readonly asset: { readonly url: string };
  }>;
  readonly removedIngredients: ReadonlyArray<{
    readonly __typename: 'Ingredient';
    readonly id: string;
    readonly name: string;
    readonly kind: Types.IngredientKind | null;
    readonly asset: { readonly url: string };
  }>;
  readonly product: {
    readonly __typename: 'Product';
    readonly id: string;
    readonly name: string;
    readonly slug: string;
    readonly isCustom: boolean;
    readonly enableDressingDetails: boolean;
    readonly asset: { readonly url: string };
    readonly ingredients: ReadonlyArray<{
      readonly __typename: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly kind: Types.IngredientKind | null;
    }>;
  };
  readonly mixedDressingDetails: ReadonlyArray<{
    readonly ingredientId: string;
    readonly weight: Types.DressingWeight;
  }>;
  readonly selectedModifiers: ReadonlyArray<{
    readonly id: number;
    readonly modifierType: Types.ModifierType | null;
    readonly cost: number;
    readonly parentId: number | null;
    readonly ingredient: {
      readonly id: string;
      readonly name: string;
      readonly kind: Types.IngredientKind | null;
    } | null;
  }>;
};

export type CartRestaurantFragment = {
  readonly __typename: 'Restaurant';
  readonly id: string;
  readonly slug: string;
  readonly name: string;
  readonly city: string;
  readonly state: string;
  readonly address: string;
  readonly zipCode: string;
  readonly isOutpost: boolean;
  readonly deliveryMinSubtotal: number;
  readonly showDeliveryFeeDisclosure: boolean;
  readonly deliveryFee: number;
  readonly availableDropOffLocations: ReadonlyArray<{
    readonly __typename: 'DropOffLocation';
    readonly id: string;
    readonly name: string;
  }>;
  readonly asset: { readonly url: string };
};

export type DeliveryOrderDetailFragment = {
  readonly __typename: 'DeliveryOrderDetail';
  readonly id: string;
  readonly tip: number;
  readonly deliveryFee: number;
  readonly vendor: string;
  readonly orderId: string;
  readonly vendorRestaurantId: string;
  readonly estimatedDeliveryTime: string | null;
  readonly address: {
    readonly __typename: 'Address';
    readonly id: string;
    readonly street: string;
    readonly secondaryStreet: string | null;
    readonly city: string;
    readonly state: string;
    readonly country: string;
    readonly zipCode: string;
    readonly deliveryPreference: Types.DeliveryPreferenceType;
    readonly googlePlaceId: string;
    readonly latitude: number;
    readonly longitude: number;
    readonly name: string | null;
    readonly notes: string | null;
  } | null;
};

export type CartDataFragment = {
  readonly __typename: 'Order';
  readonly id: string;
  readonly orderType: Types.OrderType;
  readonly orderState: Types.OrderState;
  readonly canTrackOrderStatus: boolean;
  readonly currentUserOrderPermissions: { readonly canSubmitOrder: boolean };
  readonly multipartyDetails: { readonly joinCode: string } | null;
  readonly ledger: {
    readonly tax: number;
    readonly subtotal: number;
    readonly feesTotal: number;
    readonly discountsTotal: number;
    readonly creditsTotal: number;
    readonly tip: number;
    readonly discounts: ReadonlyArray<{
      readonly __typename: 'LedgerItem';
      readonly id: string | null;
      readonly name: string;
      readonly amount: number;
      readonly description: string | null;
    }>;
    readonly credits: ReadonlyArray<{
      readonly __typename: 'LedgerItem';
      readonly id: string | null;
      readonly name: string;
      readonly amount: number;
      readonly description: string | null;
    }>;
    readonly fees: ReadonlyArray<{
      readonly __typename: 'LedgerItem';
      readonly id: string | null;
      readonly name: string;
      readonly amount: number;
      readonly description: string | null;
    }>;
  };
  readonly lineItems: ReadonlyArray<{
    readonly __typename: 'LineItem';
    readonly id: string;
    readonly slug: string;
    readonly quantity: number;
    readonly cost: number;
    readonly customName: string | null;
    readonly perItemCost: number;
    readonly favorited: boolean;
    readonly isCustom: boolean;
    readonly dressingMode: Types.DressingMode;
    readonly addedIngredients: ReadonlyArray<{
      readonly __typename: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly kind: Types.IngredientKind | null;
      readonly asset: { readonly url: string };
    }>;
    readonly removedIngredients: ReadonlyArray<{
      readonly __typename: 'Ingredient';
      readonly id: string;
      readonly name: string;
      readonly kind: Types.IngredientKind | null;
      readonly asset: { readonly url: string };
    }>;
    readonly product: {
      readonly __typename: 'Product';
      readonly id: string;
      readonly name: string;
      readonly slug: string;
      readonly isCustom: boolean;
      readonly enableDressingDetails: boolean;
      readonly asset: { readonly url: string };
      readonly ingredients: ReadonlyArray<{
        readonly __typename: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: Types.IngredientKind | null;
      }>;
    };
    readonly mixedDressingDetails: ReadonlyArray<{
      readonly ingredientId: string;
      readonly weight: Types.DressingWeight;
    }>;
    readonly selectedModifiers: ReadonlyArray<{
      readonly id: number;
      readonly modifierType: Types.ModifierType | null;
      readonly cost: number;
      readonly parentId: number | null;
      readonly ingredient: {
        readonly id: string;
        readonly name: string;
        readonly kind: Types.IngredientKind | null;
      } | null;
    }>;
  }>;
  readonly restaurant: {
    readonly __typename: 'Restaurant';
    readonly id: string;
    readonly slug: string;
    readonly name: string;
    readonly city: string;
    readonly state: string;
    readonly address: string;
    readonly zipCode: string;
    readonly isOutpost: boolean;
    readonly deliveryMinSubtotal: number;
    readonly showDeliveryFeeDisclosure: boolean;
    readonly deliveryFee: number;
    readonly availableDropOffLocations: ReadonlyArray<{
      readonly __typename: 'DropOffLocation';
      readonly id: string;
      readonly name: string;
    }>;
    readonly asset: { readonly url: string };
  };
  readonly deliveryOrderDetail: {
    readonly __typename: 'DeliveryOrderDetail';
    readonly id: string;
    readonly tip: number;
    readonly deliveryFee: number;
    readonly vendor: string;
    readonly orderId: string;
    readonly vendorRestaurantId: string;
    readonly estimatedDeliveryTime: string | null;
    readonly address: {
      readonly __typename: 'Address';
      readonly id: string;
      readonly street: string;
      readonly secondaryStreet: string | null;
      readonly city: string;
      readonly state: string;
      readonly country: string;
      readonly zipCode: string;
      readonly deliveryPreference: Types.DeliveryPreferenceType;
      readonly googlePlaceId: string;
      readonly latitude: number;
      readonly longitude: number;
      readonly name: string | null;
      readonly notes: string | null;
    } | null;
  } | null;
};

export type CartQueryVariables = Exact<{ [key: string]: never }>;

export type CartQuery = {
  readonly cart: {
    readonly __typename: 'Order';
    readonly id: string;
    readonly orderType: Types.OrderType;
    readonly orderState: Types.OrderState;
    readonly canTrackOrderStatus: boolean;
    readonly currentUserOrderPermissions: { readonly canSubmitOrder: boolean };
    readonly multipartyDetails: { readonly joinCode: string } | null;
    readonly ledger: {
      readonly tax: number;
      readonly subtotal: number;
      readonly feesTotal: number;
      readonly discountsTotal: number;
      readonly creditsTotal: number;
      readonly tip: number;
      readonly discounts: ReadonlyArray<{
        readonly __typename: 'LedgerItem';
        readonly id: string | null;
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly credits: ReadonlyArray<{
        readonly __typename: 'LedgerItem';
        readonly id: string | null;
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly fees: ReadonlyArray<{
        readonly __typename: 'LedgerItem';
        readonly id: string | null;
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
    };
    readonly lineItems: ReadonlyArray<{
      readonly __typename: 'LineItem';
      readonly id: string;
      readonly slug: string;
      readonly quantity: number;
      readonly cost: number;
      readonly customName: string | null;
      readonly perItemCost: number;
      readonly favorited: boolean;
      readonly isCustom: boolean;
      readonly dressingMode: Types.DressingMode;
      readonly addedIngredients: ReadonlyArray<{
        readonly __typename: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: Types.IngredientKind | null;
        readonly asset: { readonly url: string };
      }>;
      readonly removedIngredients: ReadonlyArray<{
        readonly __typename: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: Types.IngredientKind | null;
        readonly asset: { readonly url: string };
      }>;
      readonly product: {
        readonly __typename: 'Product';
        readonly id: string;
        readonly name: string;
        readonly slug: string;
        readonly isCustom: boolean;
        readonly enableDressingDetails: boolean;
        readonly asset: { readonly url: string };
        readonly ingredients: ReadonlyArray<{
          readonly __typename: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly kind: Types.IngredientKind | null;
        }>;
      };
      readonly mixedDressingDetails: ReadonlyArray<{
        readonly ingredientId: string;
        readonly weight: Types.DressingWeight;
      }>;
      readonly selectedModifiers: ReadonlyArray<{
        readonly id: number;
        readonly modifierType: Types.ModifierType | null;
        readonly cost: number;
        readonly parentId: number | null;
        readonly ingredient: {
          readonly id: string;
          readonly name: string;
          readonly kind: Types.IngredientKind | null;
        } | null;
      }>;
    }>;
    readonly restaurant: {
      readonly __typename: 'Restaurant';
      readonly id: string;
      readonly slug: string;
      readonly name: string;
      readonly city: string;
      readonly state: string;
      readonly address: string;
      readonly zipCode: string;
      readonly isOutpost: boolean;
      readonly deliveryMinSubtotal: number;
      readonly showDeliveryFeeDisclosure: boolean;
      readonly deliveryFee: number;
      readonly availableDropOffLocations: ReadonlyArray<{
        readonly __typename: 'DropOffLocation';
        readonly id: string;
        readonly name: string;
      }>;
      readonly asset: { readonly url: string };
    };
    readonly deliveryOrderDetail: {
      readonly __typename: 'DeliveryOrderDetail';
      readonly id: string;
      readonly tip: number;
      readonly deliveryFee: number;
      readonly vendor: string;
      readonly orderId: string;
      readonly vendorRestaurantId: string;
      readonly estimatedDeliveryTime: string | null;
      readonly address: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly street: string;
        readonly secondaryStreet: string | null;
        readonly city: string;
        readonly state: string;
        readonly country: string;
        readonly zipCode: string;
        readonly deliveryPreference: Types.DeliveryPreferenceType;
        readonly googlePlaceId: string;
        readonly latitude: number;
        readonly longitude: number;
        readonly name: string | null;
        readonly notes: string | null;
      } | null;
    } | null;
  } | null;
};

export type AddLineItemToCartSuccessFieldsFragment = {
  readonly cart: {
    readonly __typename: 'Order';
    readonly id: string;
    readonly orderType: Types.OrderType;
    readonly orderState: Types.OrderState;
    readonly canTrackOrderStatus: boolean;
    readonly currentUserOrderPermissions: { readonly canSubmitOrder: boolean };
    readonly multipartyDetails: { readonly joinCode: string } | null;
    readonly ledger: {
      readonly tax: number;
      readonly subtotal: number;
      readonly feesTotal: number;
      readonly discountsTotal: number;
      readonly creditsTotal: number;
      readonly tip: number;
      readonly discounts: ReadonlyArray<{
        readonly __typename: 'LedgerItem';
        readonly id: string | null;
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly credits: ReadonlyArray<{
        readonly __typename: 'LedgerItem';
        readonly id: string | null;
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly fees: ReadonlyArray<{
        readonly __typename: 'LedgerItem';
        readonly id: string | null;
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
    };
    readonly lineItems: ReadonlyArray<{
      readonly __typename: 'LineItem';
      readonly id: string;
      readonly slug: string;
      readonly quantity: number;
      readonly cost: number;
      readonly customName: string | null;
      readonly perItemCost: number;
      readonly favorited: boolean;
      readonly isCustom: boolean;
      readonly dressingMode: Types.DressingMode;
      readonly addedIngredients: ReadonlyArray<{
        readonly __typename: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: Types.IngredientKind | null;
        readonly asset: { readonly url: string };
      }>;
      readonly removedIngredients: ReadonlyArray<{
        readonly __typename: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: Types.IngredientKind | null;
        readonly asset: { readonly url: string };
      }>;
      readonly product: {
        readonly __typename: 'Product';
        readonly id: string;
        readonly name: string;
        readonly slug: string;
        readonly isCustom: boolean;
        readonly enableDressingDetails: boolean;
        readonly asset: { readonly url: string };
        readonly ingredients: ReadonlyArray<{
          readonly __typename: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly kind: Types.IngredientKind | null;
        }>;
      };
      readonly mixedDressingDetails: ReadonlyArray<{
        readonly ingredientId: string;
        readonly weight: Types.DressingWeight;
      }>;
      readonly selectedModifiers: ReadonlyArray<{
        readonly id: number;
        readonly modifierType: Types.ModifierType | null;
        readonly cost: number;
        readonly parentId: number | null;
        readonly ingredient: {
          readonly id: string;
          readonly name: string;
          readonly kind: Types.IngredientKind | null;
        } | null;
      }>;
    }>;
    readonly restaurant: {
      readonly __typename: 'Restaurant';
      readonly id: string;
      readonly slug: string;
      readonly name: string;
      readonly city: string;
      readonly state: string;
      readonly address: string;
      readonly zipCode: string;
      readonly isOutpost: boolean;
      readonly deliveryMinSubtotal: number;
      readonly showDeliveryFeeDisclosure: boolean;
      readonly deliveryFee: number;
      readonly availableDropOffLocations: ReadonlyArray<{
        readonly __typename: 'DropOffLocation';
        readonly id: string;
        readonly name: string;
      }>;
      readonly asset: { readonly url: string };
    };
    readonly deliveryOrderDetail: {
      readonly __typename: 'DeliveryOrderDetail';
      readonly id: string;
      readonly tip: number;
      readonly deliveryFee: number;
      readonly vendor: string;
      readonly orderId: string;
      readonly vendorRestaurantId: string;
      readonly estimatedDeliveryTime: string | null;
      readonly address: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly street: string;
        readonly secondaryStreet: string | null;
        readonly city: string;
        readonly state: string;
        readonly country: string;
        readonly zipCode: string;
        readonly deliveryPreference: Types.DeliveryPreferenceType;
        readonly googlePlaceId: string;
        readonly latitude: number;
        readonly longitude: number;
        readonly name: string | null;
        readonly notes: string | null;
      } | null;
    } | null;
  };
};

export type EditLineItemInCartSuccessFieldsFragment = {
  readonly cart: {
    readonly __typename: 'Order';
    readonly id: string;
    readonly orderType: Types.OrderType;
    readonly orderState: Types.OrderState;
    readonly canTrackOrderStatus: boolean;
    readonly currentUserOrderPermissions: { readonly canSubmitOrder: boolean };
    readonly multipartyDetails: { readonly joinCode: string } | null;
    readonly ledger: {
      readonly tax: number;
      readonly subtotal: number;
      readonly feesTotal: number;
      readonly discountsTotal: number;
      readonly creditsTotal: number;
      readonly tip: number;
      readonly discounts: ReadonlyArray<{
        readonly __typename: 'LedgerItem';
        readonly id: string | null;
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly credits: ReadonlyArray<{
        readonly __typename: 'LedgerItem';
        readonly id: string | null;
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly fees: ReadonlyArray<{
        readonly __typename: 'LedgerItem';
        readonly id: string | null;
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
    };
    readonly lineItems: ReadonlyArray<{
      readonly __typename: 'LineItem';
      readonly id: string;
      readonly slug: string;
      readonly quantity: number;
      readonly cost: number;
      readonly customName: string | null;
      readonly perItemCost: number;
      readonly favorited: boolean;
      readonly isCustom: boolean;
      readonly dressingMode: Types.DressingMode;
      readonly addedIngredients: ReadonlyArray<{
        readonly __typename: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: Types.IngredientKind | null;
        readonly asset: { readonly url: string };
      }>;
      readonly removedIngredients: ReadonlyArray<{
        readonly __typename: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: Types.IngredientKind | null;
        readonly asset: { readonly url: string };
      }>;
      readonly product: {
        readonly __typename: 'Product';
        readonly id: string;
        readonly name: string;
        readonly slug: string;
        readonly isCustom: boolean;
        readonly enableDressingDetails: boolean;
        readonly asset: { readonly url: string };
        readonly ingredients: ReadonlyArray<{
          readonly __typename: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly kind: Types.IngredientKind | null;
        }>;
      };
      readonly mixedDressingDetails: ReadonlyArray<{
        readonly ingredientId: string;
        readonly weight: Types.DressingWeight;
      }>;
      readonly selectedModifiers: ReadonlyArray<{
        readonly id: number;
        readonly modifierType: Types.ModifierType | null;
        readonly cost: number;
        readonly parentId: number | null;
        readonly ingredient: {
          readonly id: string;
          readonly name: string;
          readonly kind: Types.IngredientKind | null;
        } | null;
      }>;
    }>;
    readonly restaurant: {
      readonly __typename: 'Restaurant';
      readonly id: string;
      readonly slug: string;
      readonly name: string;
      readonly city: string;
      readonly state: string;
      readonly address: string;
      readonly zipCode: string;
      readonly isOutpost: boolean;
      readonly deliveryMinSubtotal: number;
      readonly showDeliveryFeeDisclosure: boolean;
      readonly deliveryFee: number;
      readonly availableDropOffLocations: ReadonlyArray<{
        readonly __typename: 'DropOffLocation';
        readonly id: string;
        readonly name: string;
      }>;
      readonly asset: { readonly url: string };
    };
    readonly deliveryOrderDetail: {
      readonly __typename: 'DeliveryOrderDetail';
      readonly id: string;
      readonly tip: number;
      readonly deliveryFee: number;
      readonly vendor: string;
      readonly orderId: string;
      readonly vendorRestaurantId: string;
      readonly estimatedDeliveryTime: string | null;
      readonly address: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly street: string;
        readonly secondaryStreet: string | null;
        readonly city: string;
        readonly state: string;
        readonly country: string;
        readonly zipCode: string;
        readonly deliveryPreference: Types.DeliveryPreferenceType;
        readonly googlePlaceId: string;
        readonly latitude: number;
        readonly longitude: number;
        readonly name: string | null;
        readonly notes: string | null;
      } | null;
    } | null;
  };
};

export type RemoveFromCartSuccessFieldsFragment = {
  readonly cart: {
    readonly __typename: 'Order';
    readonly id: string;
    readonly orderType: Types.OrderType;
    readonly orderState: Types.OrderState;
    readonly canTrackOrderStatus: boolean;
    readonly currentUserOrderPermissions: { readonly canSubmitOrder: boolean };
    readonly multipartyDetails: { readonly joinCode: string } | null;
    readonly ledger: {
      readonly tax: number;
      readonly subtotal: number;
      readonly feesTotal: number;
      readonly discountsTotal: number;
      readonly creditsTotal: number;
      readonly tip: number;
      readonly discounts: ReadonlyArray<{
        readonly __typename: 'LedgerItem';
        readonly id: string | null;
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly credits: ReadonlyArray<{
        readonly __typename: 'LedgerItem';
        readonly id: string | null;
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
      readonly fees: ReadonlyArray<{
        readonly __typename: 'LedgerItem';
        readonly id: string | null;
        readonly name: string;
        readonly amount: number;
        readonly description: string | null;
      }>;
    };
    readonly lineItems: ReadonlyArray<{
      readonly __typename: 'LineItem';
      readonly id: string;
      readonly slug: string;
      readonly quantity: number;
      readonly cost: number;
      readonly customName: string | null;
      readonly perItemCost: number;
      readonly favorited: boolean;
      readonly isCustom: boolean;
      readonly dressingMode: Types.DressingMode;
      readonly addedIngredients: ReadonlyArray<{
        readonly __typename: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: Types.IngredientKind | null;
        readonly asset: { readonly url: string };
      }>;
      readonly removedIngredients: ReadonlyArray<{
        readonly __typename: 'Ingredient';
        readonly id: string;
        readonly name: string;
        readonly kind: Types.IngredientKind | null;
        readonly asset: { readonly url: string };
      }>;
      readonly product: {
        readonly __typename: 'Product';
        readonly id: string;
        readonly name: string;
        readonly slug: string;
        readonly isCustom: boolean;
        readonly enableDressingDetails: boolean;
        readonly asset: { readonly url: string };
        readonly ingredients: ReadonlyArray<{
          readonly __typename: 'Ingredient';
          readonly id: string;
          readonly name: string;
          readonly kind: Types.IngredientKind | null;
        }>;
      };
      readonly mixedDressingDetails: ReadonlyArray<{
        readonly ingredientId: string;
        readonly weight: Types.DressingWeight;
      }>;
      readonly selectedModifiers: ReadonlyArray<{
        readonly id: number;
        readonly modifierType: Types.ModifierType | null;
        readonly cost: number;
        readonly parentId: number | null;
        readonly ingredient: {
          readonly id: string;
          readonly name: string;
          readonly kind: Types.IngredientKind | null;
        } | null;
      }>;
    }>;
    readonly restaurant: {
      readonly __typename: 'Restaurant';
      readonly id: string;
      readonly slug: string;
      readonly name: string;
      readonly city: string;
      readonly state: string;
      readonly address: string;
      readonly zipCode: string;
      readonly isOutpost: boolean;
      readonly deliveryMinSubtotal: number;
      readonly showDeliveryFeeDisclosure: boolean;
      readonly deliveryFee: number;
      readonly availableDropOffLocations: ReadonlyArray<{
        readonly __typename: 'DropOffLocation';
        readonly id: string;
        readonly name: string;
      }>;
      readonly asset: { readonly url: string };
    };
    readonly deliveryOrderDetail: {
      readonly __typename: 'DeliveryOrderDetail';
      readonly id: string;
      readonly tip: number;
      readonly deliveryFee: number;
      readonly vendor: string;
      readonly orderId: string;
      readonly vendorRestaurantId: string;
      readonly estimatedDeliveryTime: string | null;
      readonly address: {
        readonly __typename: 'Address';
        readonly id: string;
        readonly street: string;
        readonly secondaryStreet: string | null;
        readonly city: string;
        readonly state: string;
        readonly country: string;
        readonly zipCode: string;
        readonly deliveryPreference: Types.DeliveryPreferenceType;
        readonly googlePlaceId: string;
        readonly latitude: number;
        readonly longitude: number;
        readonly name: string | null;
        readonly notes: string | null;
      } | null;
    } | null;
  };
};

export type RestaurantMaxQuantityExceededFieldsFragment = {
  readonly message: string;
  readonly status: number;
};

export type MaxModificationsExceededFieldsFragment = {
  readonly message: string;
  readonly status: number;
};

export type LineItemModificationsInvalidFieldsFragment = {
  readonly message: string;
  readonly status: number;
};

export type RestaurantMaxDeliveryQuantityExceededFieldsFragment = {
  readonly message: string;
  readonly status: number;
};

export type ProductOutOfStockFieldsFragment = { readonly message: string; readonly status: number };

export type LocationClosedFieldsFragment = { readonly message: string; readonly status: number };

export type AddLineItemToCartMutationVariables = Exact<{
  input: Types.AddLineItemToCartInput;
}>;

export type AddLineItemToCartMutation = {
  readonly addLineItemToCart:
    | {
        readonly __typename: 'AddLineItemToCartSuccess';
        readonly cart: {
          readonly __typename: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly orderState: Types.OrderState;
          readonly canTrackOrderStatus: boolean;
          readonly currentUserOrderPermissions: { readonly canSubmitOrder: boolean };
          readonly multipartyDetails: { readonly joinCode: string } | null;
          readonly ledger: {
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: Types.DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly url: string };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly url: string };
            }>;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly enableDressingDetails: boolean;
              readonly asset: { readonly url: string };
              readonly ingredients: ReadonlyArray<{
                readonly __typename: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly ingredientId: string;
              readonly weight: Types.DressingWeight;
            }>;
            readonly selectedModifiers: ReadonlyArray<{
              readonly id: number;
              readonly modifierType: Types.ModifierType | null;
              readonly cost: number;
              readonly parentId: number | null;
              readonly ingredient: {
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              } | null;
            }>;
          }>;
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly showDeliveryFeeDisclosure: boolean;
            readonly deliveryFee: number;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: { readonly url: string };
          };
          readonly deliveryOrderDetail: {
            readonly __typename: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: Types.DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            } | null;
          } | null;
        };
      }
    | { readonly __typename: 'InvalidAddress' }
    | {
        readonly __typename: 'LineItemModificationsInvalidException';
        readonly message: string;
        readonly status: number;
      }
    | { readonly __typename: 'LocationClosed'; readonly message: string; readonly status: number }
    | { readonly __typename: 'LoyaltyScanTokenExpired' }
    | { readonly __typename: 'MaxEntreeReached' }
    | {
        readonly __typename: 'MaxModificationsExceeded';
        readonly message: string;
        readonly status: number;
      }
    | { readonly __typename: 'OrderLocked' }
    | {
        readonly __typename: 'ProductOutOfStock';
        readonly message: string;
        readonly status: number;
      }
    | { readonly __typename: 'ProductUnavailable' }
    | { readonly __typename: 'RestaurantHoursMissing' }
    | {
        readonly __typename: 'RestaurantMaxDeliveryQuantityExceeded';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'RestaurantMaxQuantityExceeded';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{ readonly field: string; readonly message: string }>;
      };
};

export type EditLineItemInCartMutationVariables = Exact<{
  input: Types.EditLineItemInCartInput;
}>;

export type EditLineItemInCartMutation = {
  readonly editLineItemInCart:
    | { readonly __typename: 'CartNotFound' }
    | {
        readonly __typename: 'EditLineItemInCartSuccess';
        readonly cart: {
          readonly __typename: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly orderState: Types.OrderState;
          readonly canTrackOrderStatus: boolean;
          readonly currentUserOrderPermissions: { readonly canSubmitOrder: boolean };
          readonly multipartyDetails: { readonly joinCode: string } | null;
          readonly ledger: {
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: Types.DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly url: string };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly url: string };
            }>;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly enableDressingDetails: boolean;
              readonly asset: { readonly url: string };
              readonly ingredients: ReadonlyArray<{
                readonly __typename: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly ingredientId: string;
              readonly weight: Types.DressingWeight;
            }>;
            readonly selectedModifiers: ReadonlyArray<{
              readonly id: number;
              readonly modifierType: Types.ModifierType | null;
              readonly cost: number;
              readonly parentId: number | null;
              readonly ingredient: {
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              } | null;
            }>;
          }>;
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly showDeliveryFeeDisclosure: boolean;
            readonly deliveryFee: number;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: { readonly url: string };
          };
          readonly deliveryOrderDetail: {
            readonly __typename: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: Types.DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            } | null;
          } | null;
        };
      }
    | { readonly __typename: 'LineItemModificationsInvalidException' }
    | { readonly __typename: 'LocationClosed'; readonly message: string; readonly status: number }
    | { readonly __typename: 'LoyaltyScanTokenExpired' }
    | { readonly __typename: 'MaxEntreeReached' }
    | {
        readonly __typename: 'MaxModificationsExceeded';
        readonly message: string;
        readonly status: number;
      }
    | { readonly __typename: 'OrderLocked' }
    | { readonly __typename: 'ProductOutOfStock' }
    | { readonly __typename: 'RestaurantHoursMissing' }
    | {
        readonly __typename: 'RestaurantMaxDeliveryQuantityExceeded';
        readonly message: string;
        readonly status: number;
      }
    | {
        readonly __typename: 'RestaurantMaxQuantityExceeded';
        readonly message: string;
        readonly status: number;
      }
    | { readonly __typename: 'UnauthorizedLineItemModification' }
    | { readonly __typename: 'UnauthorizedOrderModification' }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{ readonly field: string; readonly message: string }>;
      };
};

export type RemoveFromCartMutationVariables = Exact<{
  input: Types.RemoveFromCartInput;
}>;

export type RemoveFromCartMutation = {
  readonly removeFromCart:
    | { readonly __typename: 'CartNotFound' }
    | { readonly __typename: 'LocationClosed'; readonly message: string; readonly status: number }
    | { readonly __typename: 'LoyaltyScanTokenExpired' }
    | { readonly __typename: 'OrderLocked' }
    | {
        readonly __typename: 'RemoveFromCartSuccess';
        readonly cart: {
          readonly __typename: 'Order';
          readonly id: string;
          readonly orderType: Types.OrderType;
          readonly orderState: Types.OrderState;
          readonly canTrackOrderStatus: boolean;
          readonly currentUserOrderPermissions: { readonly canSubmitOrder: boolean };
          readonly multipartyDetails: { readonly joinCode: string } | null;
          readonly ledger: {
            readonly tax: number;
            readonly subtotal: number;
            readonly feesTotal: number;
            readonly discountsTotal: number;
            readonly creditsTotal: number;
            readonly tip: number;
            readonly discounts: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly credits: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
            readonly fees: ReadonlyArray<{
              readonly __typename: 'LedgerItem';
              readonly id: string | null;
              readonly name: string;
              readonly amount: number;
              readonly description: string | null;
            }>;
          };
          readonly lineItems: ReadonlyArray<{
            readonly __typename: 'LineItem';
            readonly id: string;
            readonly slug: string;
            readonly quantity: number;
            readonly cost: number;
            readonly customName: string | null;
            readonly perItemCost: number;
            readonly favorited: boolean;
            readonly isCustom: boolean;
            readonly dressingMode: Types.DressingMode;
            readonly addedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly url: string };
            }>;
            readonly removedIngredients: ReadonlyArray<{
              readonly __typename: 'Ingredient';
              readonly id: string;
              readonly name: string;
              readonly kind: Types.IngredientKind | null;
              readonly asset: { readonly url: string };
            }>;
            readonly product: {
              readonly __typename: 'Product';
              readonly id: string;
              readonly name: string;
              readonly slug: string;
              readonly isCustom: boolean;
              readonly enableDressingDetails: boolean;
              readonly asset: { readonly url: string };
              readonly ingredients: ReadonlyArray<{
                readonly __typename: 'Ingredient';
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              }>;
            };
            readonly mixedDressingDetails: ReadonlyArray<{
              readonly ingredientId: string;
              readonly weight: Types.DressingWeight;
            }>;
            readonly selectedModifiers: ReadonlyArray<{
              readonly id: number;
              readonly modifierType: Types.ModifierType | null;
              readonly cost: number;
              readonly parentId: number | null;
              readonly ingredient: {
                readonly id: string;
                readonly name: string;
                readonly kind: Types.IngredientKind | null;
              } | null;
            }>;
          }>;
          readonly restaurant: {
            readonly __typename: 'Restaurant';
            readonly id: string;
            readonly slug: string;
            readonly name: string;
            readonly city: string;
            readonly state: string;
            readonly address: string;
            readonly zipCode: string;
            readonly isOutpost: boolean;
            readonly deliveryMinSubtotal: number;
            readonly showDeliveryFeeDisclosure: boolean;
            readonly deliveryFee: number;
            readonly availableDropOffLocations: ReadonlyArray<{
              readonly __typename: 'DropOffLocation';
              readonly id: string;
              readonly name: string;
            }>;
            readonly asset: { readonly url: string };
          };
          readonly deliveryOrderDetail: {
            readonly __typename: 'DeliveryOrderDetail';
            readonly id: string;
            readonly tip: number;
            readonly deliveryFee: number;
            readonly vendor: string;
            readonly orderId: string;
            readonly vendorRestaurantId: string;
            readonly estimatedDeliveryTime: string | null;
            readonly address: {
              readonly __typename: 'Address';
              readonly id: string;
              readonly street: string;
              readonly secondaryStreet: string | null;
              readonly city: string;
              readonly state: string;
              readonly country: string;
              readonly zipCode: string;
              readonly deliveryPreference: Types.DeliveryPreferenceType;
              readonly googlePlaceId: string;
              readonly latitude: number;
              readonly longitude: number;
              readonly name: string | null;
              readonly notes: string | null;
            } | null;
          } | null;
        };
      }
    | { readonly __typename: 'UnauthorizedLineItemModification' }
    | { readonly __typename: 'UnauthorizedOrderModification' }
    | {
        readonly __typename: 'ValidationError';
        readonly message: string;
        readonly status: number;
        readonly fieldErrors: ReadonlyArray<{ readonly field: string; readonly message: string }>;
      };
};

export const CartLedgerFragmentDoc = gql`
  fragment CartLedger on Ledger {
    tax
    subtotal
    feesTotal
    discountsTotal
    creditsTotal
    tip
    discounts {
      id
      __typename
      name
      amount
      description
    }
    credits {
      id
      __typename
      name
      amount
      description
    }
    fees {
      id
      __typename
      name
      amount
      description
    }
  }
`;
export const CartLineItemFragmentDoc = gql`
  fragment CartLineItem on LineItem {
    id
    __typename
    slug
    quantity
    cost
    customName
    perItemCost
    favorited
    isCustom
    addedIngredients {
      id
      __typename
      name
      kind
      asset {
        url
      }
    }
    removedIngredients {
      id
      __typename
      name
      kind
      asset {
        url
      }
    }
    product {
      id
      __typename
      name
      slug
      isCustom
      enableDressingDetails
      asset {
        url
      }
      ingredients {
        id
        __typename
        name
        kind
      }
    }
    mixedDressingDetails {
      ingredientId
      weight
    }
    dressingMode
    selectedModifiers {
      id
      modifierType
      cost
      parentId
      ingredient {
        id
        name
        kind
      }
    }
  }
`;
export const CartRestaurantFragmentDoc = gql`
  fragment CartRestaurant on Restaurant {
    id
    __typename
    slug
    name
    city
    state
    address
    zipCode
    isOutpost
    deliveryMinSubtotal
    isOutpost
    showDeliveryFeeDisclosure
    deliveryFee
    availableDropOffLocations {
      id
      __typename
      name
    }
    asset {
      url
    }
  }
`;
export const DeliveryOrderDetailFragmentDoc = gql`
  fragment DeliveryOrderDetail on DeliveryOrderDetail {
    id
    __typename
    tip
    deliveryFee
    vendor
    orderId
    vendorRestaurantId
    estimatedDeliveryTime
    address {
      id
      __typename
      street
      secondaryStreet
      city
      state
      country
      zipCode
      deliveryPreference
      googlePlaceId
      latitude
      longitude
      name
      notes
    }
  }
`;
export const CartDataFragmentDoc = gql`
  fragment CartData on Order {
    id
    __typename
    orderType
    orderState
    canTrackOrderStatus
    currentUserOrderPermissions {
      canSubmitOrder
    }
    multipartyDetails {
      joinCode
    }
    ledger {
      ...CartLedger
    }
    lineItems {
      ...CartLineItem
    }
    restaurant {
      ...CartRestaurant
    }
    deliveryOrderDetail {
      ...DeliveryOrderDetail
    }
  }
  ${CartLedgerFragmentDoc}
  ${CartLineItemFragmentDoc}
  ${CartRestaurantFragmentDoc}
  ${DeliveryOrderDetailFragmentDoc}
`;
export const AddLineItemToCartSuccessFieldsFragmentDoc = gql`
  fragment AddLineItemToCartSuccessFields on AddLineItemToCartSuccess {
    cart {
      ...CartData
    }
  }
  ${CartDataFragmentDoc}
`;
export const EditLineItemInCartSuccessFieldsFragmentDoc = gql`
  fragment EditLineItemInCartSuccessFields on EditLineItemInCartSuccess {
    cart {
      ...CartData
    }
  }
  ${CartDataFragmentDoc}
`;
export const RemoveFromCartSuccessFieldsFragmentDoc = gql`
  fragment RemoveFromCartSuccessFields on RemoveFromCartSuccess {
    cart {
      ...CartData
    }
  }
  ${CartDataFragmentDoc}
`;
export const RestaurantMaxQuantityExceededFieldsFragmentDoc = gql`
  fragment RestaurantMaxQuantityExceededFields on RestaurantMaxQuantityExceeded {
    message
    status
  }
`;
export const MaxModificationsExceededFieldsFragmentDoc = gql`
  fragment MaxModificationsExceededFields on MaxModificationsExceeded {
    message
    status
  }
`;
export const LineItemModificationsInvalidFieldsFragmentDoc = gql`
  fragment LineItemModificationsInvalidFields on LineItemModificationsInvalidException {
    message
    status
  }
`;
export const RestaurantMaxDeliveryQuantityExceededFieldsFragmentDoc = gql`
  fragment RestaurantMaxDeliveryQuantityExceededFields on RestaurantMaxDeliveryQuantityExceeded {
    message
    status
  }
`;
export const ProductOutOfStockFieldsFragmentDoc = gql`
  fragment ProductOutOfStockFields on ProductOutOfStock {
    message
    status
  }
`;
export const LocationClosedFieldsFragmentDoc = gql`
  fragment LocationClosedFields on LocationClosed {
    message
    status
  }
`;
export const CartDocument = gql`
  query Cart {
    cart {
      ...CartData
    }
  }
  ${CartDataFragmentDoc}
`;

export function useCartQuery(options?: Omit<Urql.UseQueryArgs<CartQueryVariables>, 'query'>) {
  return Urql.useQuery<CartQuery, CartQueryVariables>({ query: CartDocument, ...options });
}
export const AddLineItemToCartDocument = gql`
  mutation AddLineItemToCart($input: AddLineItemToCartInput!) {
    addLineItemToCart(input: $input) {
      __typename
      ...AddLineItemToCartSuccessFields
      ...RestaurantMaxQuantityExceededFields
      ...RestaurantMaxDeliveryQuantityExceededFields
      ...MaxModificationsExceededFields
      ...ValidationErrorFields
      ...ProductOutOfStockFields
      ...LocationClosedFields
      ...LineItemModificationsInvalidFields
    }
  }
  ${AddLineItemToCartSuccessFieldsFragmentDoc}
  ${RestaurantMaxQuantityExceededFieldsFragmentDoc}
  ${RestaurantMaxDeliveryQuantityExceededFieldsFragmentDoc}
  ${MaxModificationsExceededFieldsFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
  ${ProductOutOfStockFieldsFragmentDoc}
  ${LocationClosedFieldsFragmentDoc}
  ${LineItemModificationsInvalidFieldsFragmentDoc}
`;

export function useAddLineItemToCartMutation() {
  return Urql.useMutation<AddLineItemToCartMutation, AddLineItemToCartMutationVariables>(
    AddLineItemToCartDocument,
  );
}
export const EditLineItemInCartDocument = gql`
  mutation EditLineItemInCart($input: EditLineItemInCartInput!) {
    editLineItemInCart(input: $input) {
      __typename
      ...EditLineItemInCartSuccessFields
      ...RestaurantMaxQuantityExceededFields
      ...RestaurantMaxDeliveryQuantityExceededFields
      ...MaxModificationsExceededFields
      ...ValidationErrorFields
      ...LocationClosedFields
    }
  }
  ${EditLineItemInCartSuccessFieldsFragmentDoc}
  ${RestaurantMaxQuantityExceededFieldsFragmentDoc}
  ${RestaurantMaxDeliveryQuantityExceededFieldsFragmentDoc}
  ${MaxModificationsExceededFieldsFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
  ${LocationClosedFieldsFragmentDoc}
`;

export function useEditLineItemInCartMutation() {
  return Urql.useMutation<EditLineItemInCartMutation, EditLineItemInCartMutationVariables>(
    EditLineItemInCartDocument,
  );
}
export const RemoveFromCartDocument = gql`
  mutation RemoveFromCart($input: RemoveFromCartInput!) {
    removeFromCart(input: $input) {
      __typename
      ...RemoveFromCartSuccessFields
      ...ValidationErrorFields
      ...LocationClosedFields
    }
  }
  ${RemoveFromCartSuccessFieldsFragmentDoc}
  ${ValidationErrorFieldsFragmentDoc}
  ${LocationClosedFieldsFragmentDoc}
`;

export function useRemoveFromCartMutation() {
  return Urql.useMutation<RemoveFromCartMutation, RemoveFromCartMutationVariables>(
    RemoveFromCartDocument,
  );
}
